import { useAppContext } from "../context/useAppContext";

export const GetPermissions = (keys = []) => {
  let visible = false;
  const { contextData } = useAppContext();
  const permissions = contextData?.permissions;

  if (keys?.length > 0 && permissions?.length > 0) {
    keys?.some((key) => (visible = permissions?.includes(key)));
  }

  return visible;
};
